import { render, staticRenderFns } from "./TheAppColorpicker.vue?vue&type=template&id=f271921c&"
import script from "./TheAppColorpicker.vue?vue&type=script&lang=js&"
export * from "./TheAppColorpicker.vue?vue&type=script&lang=js&"
import style0 from "./TheAppColorpicker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports